/**
 * Peak DNA Before/After Image Slider
 * Drag-based comparison slider for before/after images
 */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-before-after]').forEach(function(container) {
      var slider = container.querySelector('[data-slider-line]');
      var beforeClip = container.querySelector('[data-before-clip]');
      var position = 50;
      var isDragging = false;

      function updatePosition(clientX) {
        var rect = container.getBoundingClientRect();
        var x = Math.max(0, Math.min(clientX - rect.left, rect.width));
        position = (x / rect.width) * 100;
        beforeClip.style.clipPath = 'inset(0 ' + (100 - position) + '% 0 0)';
        slider.style.left = position + '%';
      }

      container.addEventListener('mousedown', function(e) {
        isDragging = true;
        updatePosition(e.clientX);
      });

      document.addEventListener('mousemove', function(e) {
        if (isDragging) {
          e.preventDefault();
          updatePosition(e.clientX);
        }
      });

      document.addEventListener('mouseup', function() {
        isDragging = false;
      });

      container.addEventListener('touchstart', function(e) {
        isDragging = true;
        updatePosition(e.touches[0].clientX);
      }, { passive: true });

      container.addEventListener('touchmove', function(e) {
        if (isDragging) {
          updatePosition(e.touches[0].clientX);
        }
      }, { passive: true });

      container.addEventListener('touchend', function() {
        isDragging = false;
      });
    });
  });
})();
